import React from 'react'

const features = [
  { name: 'Ilość projektów', values: ['30', '∞', '∞'] },
  { name: 'Zapisywanie produktów z internetu', values: [true, true, true] },
  { name: 'Eksport list do Excel', values: [false, true, true] },
  { name: 'Eksport listy do PDF', values: [true, true, true] },
  { name: 'Eksport PDF jako moodboard', values: [false, true, true] },
  { name: 'Filtrowanie listy', values: [true, true, true] },
  { name: 'Kopiowanie list i sekcji', values: [false, true, true] },
  { name: 'Eksport PDF + Excel z ukryciem danych', values: [false, true, true] },
  { name: 'Dodawanie logo i wizytówki', values: [true, true, true] },
  { name: 'Tworzenie propozycji online', values: [false, true, true] },
  { name: 'Tworzenie folderów', values: [false, true, true] },
  { name: 'Dodawanie notatek na liście', values: [false, true, true] },
  { name: 'Wizualizacje na liście', values: [false, false, true] },
  { name: 'Załączniki do produktów', values: [false, false, true] },
  { name: 'Widok tabelaryczny listy', values: [false, true, true] },
  { name: 'Widok moodboard', values: [true, true, true] },
  { name: 'Harmonogram i praca zespołowa', values: [false, false, true] },
  { name: 'Planowanie zadań na tablicy', values: [false, false, true] },
  { name: 'Zależności między zadaniami', values: [false, false, true] },
  { name: 'Dostęp zespołu do listy', values: [false, false, true] },
  { name: 'Logo i dane w PDF', values: [true, true, true] },
  { name: 'Notatki pod listą PDF/Excel', values: [false, false, true] },
  { name: 'Komentarze zespołu', values: [false, false, true] },
  { name: 'Edycja listy przez zespół', values: [false, 'od 2 stanowisk', true] },
  { name: 'Podgląd listy przez zespół', values: [false, 'od 2 stanowisk', true] }
]

const plans = ['START', 'PLUS', 'PREMIUM']

const CheckIcon = () => (
  <svg className='tw-w-5 tw-h-5 tw-text-green tw-inline' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor'>
    <path fillRule='evenodd' d='M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.052-.143z' clipRule='evenodd' />
  </svg>
)
const XIcon = () => (
  <svg className='tw-w-5 tw-h-5 tw-text-pink-600 tw-inline' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor'>
    <path fillRule='evenodd' d='M10 8.586l4.95-4.95a1 1 0 111.414 1.414L11.414 10l4.95 4.95a1 1 0 01-1.414 1.414L10 11.414l-4.95 4.95a1 1 0 01-1.414-1.414L8.586 10l-4.95-4.95A1 1 0 115.05 3.636L10 8.586z' clipRule='evenodd' />
  </svg>
)
const InfinityIcon = () => (
  <span className='tw-text-lg tw-font-bold tw-text-teal'>∞</span>
)

const PricingComparisonTable: React.FC = () => (
  <div className='tw-bg-slate-50 tw-py-12'>
    <div className='tw-container tw-mx-auto tw-px-4'>
      <h2 className='tw-text-2xl tw-font-bold tw-text-center tw-mb-6'>Premium daje pełnię możliwości</h2>
      <p className='tw-text-center tw-text-slate-600 tw-mb-8'>Porównanie funkcji dostępnych w planach START, PLUS i PREMIUM</p>
      <div className='tw-overflow-x-auto'>
        <table className='tw-min-w-full tw-bg-white tw-rounded-2xl tw-shadow tw-text-sm md:tw-text-base'>
          <thead>
            <tr>
              <th className='tw-p-3 tw-bg-slate-100 tw-font-semibold tw-text-left'>Funkcja</th>
              {plans.map(plan => (
                <th key={plan} className='tw-p-3 tw-bg-slate-100 tw-font-semibold tw-text-center'>{plan}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {features.map((feature, idx) => (
              <tr key={feature.name} className={idx % 2 === 0 ? 'tw-bg-slate-50' : ''}>
                <td className='tw-p-3 tw-font-medium tw-text-slate-700'>{feature.name}</td>
                {feature.values.map((val, i) => (
                  <td key={i} className='tw-p-3 tw-text-center'>
                    {val === true && <CheckIcon />}
                    {val === false && <XIcon />}
                    {val === '∞' && <InfinityIcon />}
                    {typeof val === 'string' && val !== '∞' && val !== 'od 2 stanowisk' && val !== '' && val !== 'false' && val !== 'true' && val}
                    {val === 'od 2 stanowisk' && <span className='tw-text-xs tw-text-slate-500'>od 2 stanowisk</span>}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className='tw-mt-4 tw-text-xs tw-text-slate-500 tw-text-center'>
        <div className='tw-flex tw-justify-center tw-gap-4 tw-mb-1 tw-items-center'>
          <span><CheckIcon /> = Funkcja dostępna</span>
          <span><XIcon /> = Funkcja niedostępna</span>
          <span><InfinityIcon /> = Nieograniczona liczba projektów</span>
        </div>
      </div>
    </div>
  </div>
)

export default PricingComparisonTable
